import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e55abd20&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e55abd20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55abd20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55abd20')) {
      api.createRecord('e55abd20', component.options)
    } else {
      api.reload('e55abd20', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e55abd20&scoped=true", function () {
      api.rerender('e55abd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/grade/index.vue"
export default component.exports